import { updateEntityData } from "@/api/endpoints/entityData";
import type {
  UpdateEntityDataRequest,
  UpdateEntityDataResponse,
} from "@/api/types/entityData";
import { queryKeys } from "@/lib/queryClient";
import type { UseMutationResult } from "@tanstack/react-query";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useUpdateEntityData(): UseMutationResult<
  UpdateEntityDataResponse,
  Error,
  UpdateEntityDataRequest,
  unknown
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateEntityData,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.entityData.bySession(variables.session_id),
      });

      queryClient.invalidateQueries({
        queryKey: queryKeys.entityData.all,
      });
    },
  });
}
